import React, { useEffect, useState } from "react";
import { matchPath, useLocation } from 'react-router-dom';

const locationToPath = (location) => {
    const step = location.split('/')[2];
    switch (step) {
        case 'profile':
            return '/insurance/profile/:quoteId';
        case 'aircraft':
            return '/insurance/aircraft/:quoteId';
        case 'airport':
            return '/insurance/airport/:quoteId';
        case 'pilots':
            return '/insurance/pilots/:quoteId';
        case 'pilot-list':
            return '/insurance/pilot-list/:quoteId';
        case 'coverages':
            return '/insurance/coverages/:quoteId';
        case 'summary':
            return '/insurance/summary/:quoteId';
        case 'checkout':
            return '/insurance/checkout/:quoteId';
        case 'congratulations':
            return '/insurance/congratulations/:quoteId';
        case 'declined':
            return '/insurance/declined/:quoteId';
        case 'underwritterrefferal':
            return '/insurance/underwritterrefferal/:quoteId';
        case 'notcleared':
            return '/insurance/notcleared/:quoteId';
        case 'wearealmostthere':
            return '/insurance/wearealmostthere/:quoteId';
    }
}

const getRouteMatch = (location) => {
    const path = locationToPath(location);
    const match = matchPath(location, {
        path: path,
        exact: true,
        strict: false
      });

    return match?.params ? match.params : {};
}

const usePurchaseFlowParams = () => {
    const location = useLocation();
    const [params, setParams] = useState({});

    useEffect(() => {
        setParams(getRouteMatch(location.pathname));
    }, [location.pathname]);

    return {...params};
}

export default usePurchaseFlowParams;